<template>
    <el-dialog
        :title="title"
        :visible.sync="dialogVisible"
        width="600px"
        custom-class="script-center-dialog"
        :close-on-click-modal="false"
        :before-close="close"
        z-index="800"
        v-loading="fullscreenLoading"
        :element-loading-text="$t('DomesticTransportation.loadingStatus')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(196,196,204, 0.1)"
        >
        <div style="padding:0 16px;">
            <div v-if="currentStep === 'partOne'">
                <el-tabs v-model="activeName">
                    <el-tab-pane :label="$t('DomesticTransportation.SubscribeNow')" name="first">
                        <el-checkbox-group v-model="checkedCities">
                            <el-checkbox v-for="(subscript,index) in subScriptionList" :key="index" :label="subscript.TopicID">
                                <div style="display: flex;justify-content: space-between;align-items: center;width: 100%;">
                                    <div style="display: flex;justify-content: flex-start;align-items: center;flex:1;overflow: hidden;">
                                        <div>{{ subscript.TopicName }}：</div>
                                        <el-tooltip
                                        :content="subscript.Remark"
                                        placement="top"
                                        :disabled="!isShowTooltip"
                                        >
                                            <div style="font-size: 12px;color:#999;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;" @mouseenter="textOverflowing($event)">{{ subscript.Remark }}</div>
                                        </el-tooltip>
                                    </div>
                                    <div style="width:100px;text-align: right;font-size: 12px;color:#999;">{{ changeLang(subscript.TopicType) }}</div>
                                </div>
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('DomesticTransportation.PastSubscriptions')" name="second">
                        <div>
                            <div style="display: flex;justify-content: space-between;padding:8px 0;border-bottom: 1px solid #eee;margin-bottom: 8px;">
                                <div style="width: 150px;">{{ $t('DomesticTransportation.Subscribetothetopic') }}</div>
                                <div style="width: 180px;">{{ $t('DomesticTransportation.Subscribetotheemail') }}</div>
                                <div style="width: 80px;">{{ $t('DomesticTransportation.Subscribetonotifications') }}</div>
                                <div style="width: 100px;text-align: right;">{{ $t('DomesticTransportation.AuditStatus') }}</div>
                            </div>
                            <div v-for="(item,index) in historyScription" :key="index" style="display: flex;justify-content: space-between;padding:8px 0;">
                                <el-tooltip
                                    :content="item.TopicName"
                                    placement="top"
                                    :disabled="!isShowTooltip"
                                    >
                                     <div style="width: 150px;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;" @mouseenter="textOverflowing($event)">{{ item.TopicName }}</div>
                                </el-tooltip>
                                <div style="width: 180px;">{{ item.MailTo }}</div>
                                <div style="width: 80px;text-align: center;">
                                    <el-switch
                                    v-model="item.SubscriptionStatus"
                                    active-color="#53a2b6"
                                    inactive-color="#E2E2E3"
                                    style="margin-right: 12px;"
                                    @change="historySwitchChange(item)"
                                    >
                                    </el-switch>
                                </div>
                                <div v-if="item.AuditStatus === '已通过'" style="color:#67C067;width:100px;text-align: right;">{{ $t('DomesticTransportation.Approved') }}</div>
                                <div v-else-if="item.AuditStatus === '待审核'" style="color:#999;width:100px;text-align: right;">{{ $t('DomesticTransportation.Pendingreview') }}</div>
                                <div v-else style="color:red;width:100px;text-align: right;">{{ $t('DomesticTransportation.Rejected') }}</div>
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
                <div style="padding:12px;background-color: #ECF6F8;color: #75BBCF"><i class="el-icon-info" style="margin-right: 8px;"></i>{{ $t('DomesticTransportation.SubscriptTips3') }}</div>
            </div>
            <div v-else-if="currentStep === 'partTwo'">
                <div>{{ $t('DomesticTransportation.yourSubscript') }}</div>
                <div style="width: 100%;height: 32px;border: 1px solid #ccc;border-radius: 4px;margin-top: 8px;padding: 8px;">
                    {{ TopicNameList }}
                </div>
                <!-- <el-input
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 4}"
                    placeholder="请输入内容"
                    v-model="textarea2"
                    size="mini"
                    disabled
                    style="width: 100%;margin-top: 8px;"
                    >
                </el-input> -->
                <div style="margin-top: 16px;align-items: center;justify-content: space-between;display: flex;">
                    <div>{{ $t('DomesticTransportation.Recipientemailaddress') }}</div>
                    <el-tooltip
                    placement="top"
                    :content="$t('DomesticTransportation.AddRecipientEmailAddress')">
                    <i class="el-icon-plus" style="font-size: 20px;color:#53a2b6;cursor: pointer;" @click="addEmail()"></i>
                    </el-tooltip>
                </div>
                <div style="height:200px;overflow-y: auto;">
                    <div v-for="(item,index) in emailList" :key="index">
                        <div class="email-item">
                            <div>
                                <el-input
                                    :placeholder="$t('DomesticTransportation.Emailaddress')"
                                    v-model="item.email"
                                    size="mini"
                                    :style="{border: item.rule === 'resolve' ? '1px solid #4CCF6B' : (item.rule === 'reject' ? '1px solid red' : '1px solid #c0c4cc'),borderRadius: '4px',width:'185px'}"
                                    @change="value => emailInputChange(value,index)"
                                    >
                                </el-input>
                                <div v-if="item.rule === 'reject'" style="font-size: 12px;color:red;margin: 4px 0;">{{ $t('DomesticTransportation.formayError') }}</div>
                            </div>
                            <el-tooltip
                                v-if="emailList.length > 1"
                                placement="top"
                                :content="$t('DomesticTransportation.delete')">
                                <i class="el-icon-minus" style="font-size: 20px;color:#53a2b6;cursor: pointer;margin-top: 4px;" @click="deleteEmail(index)"></i>
                            </el-tooltip >
                        </div>
                        <div style="display: flex;justify-content: space-between;column-gap: 8px;margin-top: 8px;">
                            <el-input
                                :placeholder="$t('DomesticTransportation.Yourname')"
                                v-model="item.SubscriptionUserName"
                                size="mini"
                                :style="{border: item.nameRule === 'resolve' ? '1px solid #4CCF6B' : (item.nameRule === 'reject' ? '1px solid red' : '1px solid #c0c4cc')}"
                                style="border-radius: 3px;"
                                @blur="nameInputChange(item.SubscriptionUserName,index)"
                                >
                            </el-input>
                            <el-input
                                :placeholder="$t('DomesticTransportation.Yourposition')"
                                v-model="item.SubscriptionUserRole"
                                size="mini"
                                :style="{border: item.roleRule === 'resolve' ? '1px solid #4CCF6B' : (item.roleRule === 'reject' ? '1px solid red' : '1px solid #c0c4cc')}"
                                style="border-radius: 3px;"
                                @blur="roleInputChange(item.SubscriptionUserRole,index)"
                                >
                            </el-input>
                            <el-input
                                :placeholder="$t('DomesticTransportation.Yourcontactnumber')"
                                v-model="item.SubscriptionUserTel"
                                size="mini"
                                :style="{border: item.telRule === 'resolve' ? '1px solid #4CCF6B' : (item.telRule === 'reject' ? '1px solid red' : '1px solid #c0c4cc')}"
                                style="border-radius: 3px;"
                                @blur="telInputChange(item.SubscriptionUserTel,index)"
                                >
                            </el-input>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else-if="currentStep === 'partThree'">
                <el-input
                    type="textarea"
                    :autosize="{ minRows: 12, maxRows: 12}"
                    :placeholder="$t('DomesticTransportation.advise')"
                    v-model="feedBack"
                    size="mini"
                    style="width: 100%;margin-top: 8px;"
                    >
                </el-input>
                <div style="margin-top: 8px;color:#999">{{ $t('DomesticTransportation.adviseTips') }}</div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <!-- <el-button size="mini" @click="dialogVisible = false">取 消</el-button> -->
            <div>
                <div v-if="currentStep === 'partOne'">{{ $t('DomesticTransportation.nothingYouWant') }}<span style="color: #53a2b6;cursor: pointer;" @click="currentStep = 'partThree'">{{ $t('DomesticTransportation.clickFeedback') }}</span></div>
            </div>
            <el-button v-if="currentStep === 'partOne' && activeName === 'first'" size="mini" type="primary" @click="gotoAddEmail()">{{ $t('DomesticTransportation.NextStep') }}</el-button>
            <div v-else-if="currentStep === 'partTwo'">
                <el-button size="mini" type="primary" @click="currentStep = 'partOne'">{{ $t('DomesticTransportation.PreviousStep') }}</el-button>
                <el-button size="mini" type="primary" @click="confirmSubsciptionEmail()">{{ $t('DomesticTransportation.Confirm') }}</el-button>
            </div>
            <div v-else-if="currentStep === 'partThree'">
                <el-button size="mini" type="primary" @click="currentStep = 'partOne'" :disabled="!emailList.length">{{ $t('DomesticTransportation.PreviousStep') }}</el-button>
                <el-button size="mini" type="primary" @click="sendFeedBack()" :disabled="!emailList.length">{{ $t('DomesticTransportation.send') }}</el-button>
            </div>
        </span>
    </el-dialog>
</template>
<script>
import Cookies from 'js-cookie';
import i18n from '@/i18n/i18n'
import { GetSubscriptionList, GetTopicList, UpdateSubscriptionStatus, SaveUserSubscription, UserFeedback } from '@/api/tms'
export default {
  data() {
    return {
      dialogVisible: false,
      checkedCities: [],
      activeName: 'first',
      subScriptionList: [],
      historyScription: [],
      currentStep: 'partOne',
      emailList: [{ email: '', rule: '', nameRule: '', roleRule: '', telRule: '' }],
      title: '',
      UserAccount: '',
      UserPlatform: 'TMS',
      feedBack: '',
      TopicNameList: '',
      fullscreenLoading: false,
      lang: 'zh',
      isShowTooltip: false, // 是否显示提示文字
    }
  },
  watch: {
    currentStep: {
      handler(newVal, oldVal) {
        if (newVal === 'partOne') {
          this.title = i18n.t('DomesticTransportation.SubscriptionCenter')
        } else if (newVal === 'partTwo') {
          this.title = i18n.t('DomesticTransportation.emailConfirm')
        } else {
          this.title = i18n.t('DomesticTransportation.ListenAdvice')
        }
      }
    }
  },
  methods: {
    init() {
      const userinfo = Cookies.get('MW_USERCENTER_INFO') || ''
      if (userinfo) {
        this.UserAccount = JSON.parse(userinfo).CACode
        this.fullscreenLoading = true
        this.getDataList()
        this.getHistoryList()
      } else {
        this.$message.error(i18n.t('DomesticTransportation.notUserInfo'))
      }
    },
    close() {
      this.feedBack = ''
      this.emailList = [{ email: '', rule: '' }]
      this.currentStep = 'partOne'
      this.activeName = 'first'
      this.checkedCities = []
      this.dialogVisible = false
    },
    getDataList() {
      GetTopicList({ SystemModule: this.UserPlatform, lang: this.lang }).then(res => {
        this.subScriptionList = res.data || []
      }).finally(() => {
        this.fullscreenLoading = false
      })
    },
    getHistoryList() {
      const params = {
        UserAccount: this.UserAccount,
        // SubscriptionStatus: 'Subscription',
        SystemModule: this.UserPlatform,
        lang: this.lang
      }
      GetSubscriptionList(params).then(res => {
        const data = res.data || []
        this.historyScription = data.map(el => {
          return { ...el, SubscriptionStatus: el.SubscriptionStatus === 'Subscription' }
        })
      }).finally(() => {
        this.fullscreenLoading = false
      })
    },
    open(type) {
      this.UserPlatform = type
      this.dialogVisible = true
      this.lang = this.$ls.get('lang')
      this.init()
    },
    addEmail() {
      this.emailList.push({ email: '', rule: '', nameRule: '', roleRule: '', telRule: '' })
    },
    deleteEmail(index) {
      this.emailList.splice(index, 1)
    },
    emailInputChange(value, index) {
      if (value === '') {
        this.emailList[index].rule = 'reject'
        return
      }
      // eslint-disable-next-line
      if (value.search(/^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/) != -1) {
        this.emailList[index].rule = 'resolve'
      } else {
        this.emailList[index].rule = 'reject'
      }
    },
    nameInputChange(value, index) {
      if (!value) {
        this.emailList[index].nameRule = 'reject'
      } else {
        this.emailList[index].nameRule = 'resolve'
      }
    },
    roleInputChange(value, index) {
      if (!value) {
        this.emailList[index].roleRule = 'reject'
      } else {
        this.emailList[index].roleRule = 'resolve'
      }
    },
    telInputChange(value, index) {
      if (!value) {
        this.emailList[index].telRule = 'reject'
      } else {
        this.emailList[index].telRule = 'resolve'
      }
    },
    confirmSubsciptionEmail() {
      const rules = []
      const nameRule = []
      const roleRule = []
      const telRule = []
      this.emailList.forEach(el => {
        if (el.rule !== 'resolve') {
          rules.push(el)
          el.rule = 'reject'
        }
        if (el.nameRule !== 'resolve') {
          nameRule.push(el)
          el.nameRule = 'reject'
        }
        if (el.roleRule !== 'resolve') {
          roleRule.push(el)
          el.roleRule = 'reject'
        }
        if (el.telRule !== 'resolve') {
          telRule.push(el)
          el.telRule = 'reject'
        }
      })
      if (rules.length) {
        this.$message.error(i18n.t('DomesticTransportation.ruleEmail'))
        return
      }
      if (nameRule.length) {
        this.$message.error(i18n.t('DomesticTransportation.ruleName'))
        return
      }
      if (roleRule.length) {
        this.$message.error(i18n.t('DomesticTransportation.ruleRole'))
        return
      }
      if (telRule.length) {
        this.$message.error(i18n.t('DomesticTransportation.ruleTel'))
        return
      }
      const list = []
      this.emailList.forEach(el => {
        this.checkedCities.forEach(id => {
          list.push({
            MailTo: el.email,
            SubscriptionUserName: el.SubscriptionUserName,
            SubscriptionUserRole: el.SubscriptionUserRole,
            SubscriptionUserTel: el.SubscriptionUserTel,
            TopicID: id
          })
        })
      })
      this.fullscreenLoading = true
      const params = {
        UserAccount: this.UserAccount,
        SubscriptionList: list
      }
      SaveUserSubscription(params).then(res => {
        this.$emit('success')
        this.close()
      }).finally(() => {
        this.fullscreenLoading = false
      })
    },
    sendFeedBack() {
      if (!this.feedBack) {
        this.$message.error(i18n.t('DomesticTransportation.advise'))
        return
      }
      this.fullscreenLoading = true
      const params = {
        UserAccount: this.UserAccount,
        SystemModule: this.UserPlatform,
        FeedbackContent: this.feedBack
      }
      UserFeedback(params).then(res => {
        this.$message.success(i18n.t('DomesticTransportation.feedbackSuccess'))
        this.close()
      }).finally(() => {
        this.fullscreenLoading = false
      })
    },
    historySwitchChange(item) {
      let status = ''
      if (item.SubscriptionStatus) {
        status = 'Subscription'
      } else {
        status = 'CancelSubscription'
      }
      const params = {
        UserSubscriptionID: item.UserSubscriptionID,
        UserAccount: this.UserAccount,
        SubscriptionStatus: status
      }
      UpdateSubscriptionStatus(params).then(res => {
        this.getHistoryList()
      }).finally(() => {
        this.fullscreenLoading = false
      })
    },
    gotoAddEmail() {
      if (!this.checkedCities.length) {
        this.$message.error(i18n.t('DomesticTransportation.ruleNodeType'))
        return
      }
      this.currentStep = 'partTwo'
      const list = []
      this.subScriptionList.forEach(item => {
        this.checkedCities.forEach(el => {
          if (el === item.TopicID) {
            list.push(item.TopicName)
          }
        })
      })
      this.TopicNameList = list.join()
    },
    changeLang(status){
        let value = ''
        if(this.lang === 'zh'){
            value = status
        }else {
            if(status === '订单状态'){
                value = 'Order Status'
            }else if(status === '定期报告'){
                value = 'Regular Reports'
            }
        }
        return value
    },
    textOverflowing(event) {
      const ev = event.target
      const evWeight = ev.scrollWidth // 文本的实际宽度   scrollWidth：对象的实际内容的宽度，不包边线宽度，会随对象中内容超过可视区后而变大。
      const contentWeight = ev.clientWidth // 文本的可视宽度 clientWidth：对象内容的可视区的宽度，不包滚动条等边线，会随对象显示大小的变化而改变。
      // const content_weight = this.$refs.tlp.$el.parentNode.clientWidth; // 文本容器宽度(父节点)
      if (evWeight > contentWeight) {
        // 实际宽度 > 可视宽度  文字溢出
        this.isShowTooltip = true
      } else {
        // 否则为不溢出
        this.isShowTooltip = false
      }
    }
  },
}
</script>
<style lang="less">
.script-center-dialog {
  .el-input__inner:hover {
      border:'none'
  }
  .el-input__inner {
      border: none
  }
  .el-dialog__header {
    padding-bottom: 0;
    padding: 16px;
    .el-dialog__title {
        font-size: 16px;
        font-weight: 600;
    }
  }
  .el-dialog__body {
    padding: 0;
  }
  .el-dialog__headerbtn {
    top: 16px;
    right: 16px;
  }
  .el-tabs__active-bar,
  .el-tabs__nav-wrap::after {
    display: none;
  }
  .el-tabs__content {
    height: 50vh;
    overflow-y: auto;
  }
  .el-tabs__item {
    height: auto;
    line-height: normal;
  }
  .el-checkbox-group {
    display: flex;
    flex-direction: column;
  }
  .el-checkbox__label {
    width: 100%;
    padding:8px;
    padding-right: 16px;
  }
  .el-checkbox {
    margin-right: 0;
  }
  .dialog-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 16px;
  }
  .el-textarea__inner {
    max-width: 100%;
  }
  .email-item {
    margin-top: 16px;
    align-items: flex-start;
    justify-content: space-between;
    display: flex;
  }
}

</style>
